import { useState } from "react";

export function useToggle(initial: boolean): [boolean, () => void] {
  const [s, setS] = useState(initial);

  function toggle() {
    setS((s) => !s);
  }

  return [s, toggle];
}
